<template>
  <entity-edit-dialog
      @submit="submit"
      @close="close"
      v-model="visible"
      ref="editDialog"
      :dialog-title="$t('service.quickPartUseServiceDialog.dialogTitle')"
      :submitting="submitting">
    <template v-slot:contentCard>
      <v-card-text class="pt-5">
        <entity-dialog-input-row :label="$t('device.singular')" :required="true">
          <device-select-field :show-add-dialog-button="true"
                               :show-select-dialog-button="true"
                               v-model="quickPartUseService.device"
                               :rules="[buildRequiredValidator(),]"
                               style="max-width: 30em"/>

        </entity-dialog-input-row>


        <entity-dialog-input-row :label="$t('part.singular')" :required="true">
          <part-select-field :show-select-dialog-button="true"
                             :show-add-dialog-button="true"
                             :rules="[buildRequiredValidator(),]"
                             v-model="quickPartUseService.part"/>
        </entity-dialog-input-row>

        <entity-dialog-input-row :label="$t('service.quickPartUseServiceDialog.quantity')" :required="true">
          <div class="d-flex flex-row align-baseline">
            <v-text-field
                outlined
                hide-details="auto"
                v-model="quickPartUseService.quantity"
                min="0"
                type="number"
                class="mr-3 right-align-number-input"
                style="max-width: 6em;"
            />
            <div>{{ partUnit }}</div>
          </div>
        </entity-dialog-input-row>

        <entity-dialog-input-row :label="$t('service.doneByUsers')" :required="true">
          <multiple-users-select v-model="quickPartUseService.doneByUsers"/>
        </entity-dialog-input-row>


      </v-card-text>
    </template>
  </entity-edit-dialog>
</template>

<script>
import EntityDialogInputRow from '@/components/entity-crud/EntyDialogInputRow';
import DeviceSelectField from '@/components/inputs/DeviceSelectField';
import i18n from '@/i18n';
import EntityEditDialog from '@/components/entity-crud/EntityEditDialog';
import { buildRequiredValidator } from '@/utils/ValidatorBuilders';
import PartSelectField from '@/components/inputs/PartSelectField';
import MultipleUsersSelect from '@/components/inputs/MultipleUsersSelect';
import ServiceService from '@/services/ServiceService';

export default {
  name: 'QuickPartUseServiceDialog',
  components: {
    MultipleUsersSelect,
    PartSelectField,
    EntityEditDialog,
    DeviceSelectField,
    EntityDialogInputRow,
  },
  data: () => ({
    quickPartUseService: null,
    visible: false,
    submitting: false,

  }),
  props: {},
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },

    partUnit() {
      if (!this.quickPartUseService?.part) {
        return '';
      }
      return this.$options.filters.unit(this.quickPartUseService.part.trackingUnit.unit);
    },

  },
  methods: {
    buildRequiredValidator,
    close() {
      this.quickPartUseService = null;
      this.visible = false;
      this.submitting = false;
    },

    openCreateQuickPartUseService() {
      this.quickPartUseService = {
        doneByUsers: [],
        quantity: 1,
        part: null,
        device: null,
      };
      this.documents = [];
      this.visible = true;
    },


    submit() {
      if (this.submitting) {
        return;
      }

      if (!this.$refs.editDialog.$refs.form.validate()) {
        this.$refs.editDialog.showFormHasValidationErrorsMessage(i18n.t('service.quickPartUseServiceDialog.requiredInformationMissing'));
        return;
      }

      this.submitting = true;
      ServiceService.saveQuickPartUseService(this.quickPartUseService).then((result) => {
        this.$emit('done', result.data);
        this.close();
      }).catch(err => {
        console.log(JSON.stringify(err));
      }).finally(() => {
        this.submitting = false;
      });
    },
  },
};
</script>

<style scoped>
.repeat-weekdays > * {
  margin-right: 1em;
}
</style>
